import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiActivity, FiGlobe } from 'react-icons/fi';
import { useBuilderLabels, useBuilderLocale } from '../context/BuilderLocaleContext';
import { useWidgetBuilder } from '../context/WidgetBuilderContext';

/** Minimal header — language selector top-right (builder + widget share locale). */
export default function BuilderHeader() {
  const t = useBuilderLabels();
  const { locale, setLocale, locales } = useBuilderLocale();
  const { updateConfig } = useWidgetBuilder();

  const onLocaleChange = (next) => {
    setLocale(next);
    updateConfig({ locale: next });
  };

  return (
    <header className="h-14 bg-white border-b border-slate-200 flex items-center px-4 gap-4">
      <Link to="/" className="flex items-center gap-2 mr-2 shrink-0">
        <div className="w-8 h-8 rounded bg-brand-600 flex items-center justify-center text-white">
          <SafeIcon icon={FiActivity} className="w-5 h-5" />
        </div>
        <span className="font-bold text-lg text-slate-900 italic hidden sm:inline">Scorewidget</span>
      </Link>
      <span className="text-sm font-semibold text-slate-500 shrink-0">{t('widgetBuilder')}</span>
      <div className="ml-auto flex items-center gap-2 shrink-0">
        <label className="flex items-center gap-2 text-xs text-slate-600">
          <SafeIcon icon={FiGlobe} className="w-4 h-4 text-brand-600 shrink-0" aria-hidden />
          <span className="font-semibold uppercase hidden sm:inline">{t('interfaceLanguage')}</span>
          <select
            value={locale}
            onChange={(e) => onLocaleChange(e.target.value)}
            className="rounded-lg border-2 border-brand-300 px-2 py-1.5 text-sm font-semibold text-slate-900 bg-white min-w-[8.5rem] shadow-sm"
            aria-label={t('interfaceLanguage')}
          >
            {locales.map((loc) => (
              <option key={loc.id} value={loc.id}>
                {loc.label}
              </option>
            ))}
          </select>
        </label>
      </div>
    </header>
  );
}
